export type DateTimePickerProps = {
  showTime: boolean
  timeOnly: boolean
  showSeconds: boolean
}

/**
 * Maps platform DateTime `format` (Java SimpleDateFormat tokens) to PrimeVue DatePicker props.
 */
export function resolveDateTimePickerProps(rawFormat: unknown): DateTimePickerProps {
  const format = String(rawFormat ?? '').trim()
  const cleanedFormat = format.replace(/'[^']*'/g, '')

  const hasDateTokens = /y{1,4}|M{1,4}|d{1,2}/.test(cleanedFormat)
  const hasTimeTokens = /H{1,2}|h{1,2}|m{1,2}|s{1,2}/.test(cleanedFormat)
  const hasSecondTokens = /s{1,2}/.test(cleanedFormat)

  if (!hasDateTokens && hasTimeTokens) {
    return { showTime: true, timeOnly: true, showSeconds: hasSecondTokens }
  }
  if (hasDateTokens && hasTimeTokens) {
    return { showTime: true, timeOnly: false, showSeconds: hasSecondTokens }
  }

  return { showTime: false, timeOnly: false, showSeconds: false }
}
